import { Action, createReducer, on } from '@ngrx/store';
import { fullUpdateRetirementInfo } from '@redux/actions/retirement-info.actions';


export interface RetirementInfo {
  error: boolean
}

export const initialRetirementInfo: RetirementInfo = {
    error: false
}

const _retirementInfoReducer = createReducer(
    initialRetirementInfo,
    on(fullUpdateRetirementInfo, (state, { newretirementInfo }) => newretirementInfo)
);

export function retirementInfoReducer(retirementInfo: RetirementInfo | undefined, action: Action) {
    return _retirementInfoReducer(retirementInfo, action);
}